module.exports = __webpack_public_path__ + "static/img/mobile-03.a703b714.jpg";